module.exports = __webpack_public_path__ + "img/camera-icon.08e91820.png";